export const getCompanyPageStyle = () => ({
  companyPageInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 16px',
    gap: '8px',
    width: '100%',
    height: '76px',
    backgroundColor: '#F0F0F0',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,
  },
  imageContainer: {
    width: '60px',
    height: '60px',
    overflow: 'hidden', // Ensures content does not overflow the container
    flexShrink: 0,
    display: 'flex',
  },
  profileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  frame: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0px',
    width: '442px',
    height: '60px',

    '& .company-page-info-title': {
      fontFamily: 'Segoe UI',
      fontSize: 14,
      fontWeight: 600,
      textAlign: 'center',

      color: '#323130',
    },

    '& .company-page-info-text': {
      fontFamily: 'Segoe UI',
      fontSize: 12,
      fontWeight: 400,
      textAlign: 'center',

      color: '#323130',
    },
  },
});

